module.exports = __webpack_public_path__ + "assets/img/sandbox.47609d1e.png";